import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { seo } from "@/lib/seo";
import {
  buildFaqPageSchema,
  buildOrganizationSchema,
  buildRoofingContractorSchema,
  buildWebSiteSchema,
} from "@/lib/schema";
import { homeFaqs } from "@/components/home/HomeFAQ";

export const Route = createFileRoute("/_site/")({
  head: () =>
    seo({
      title: "Cedar Creek Construction | Roofing & Siding in Minneapolis, MN",
      description:
        "Expert roofing, siding, deck & gutter services in Minneapolis, MN. Licensed contractor #BC645307. Call (612) 298-9865 for a free estimate.",
      path: "/",
      jsonLd: [
        buildOrganizationSchema(),
        buildWebSiteSchema(),
        buildRoofingContractorSchema(),
        buildFaqPageSchema(homeFaqs),
      ],
    }),
  component: Index,
});
